import img1 from "../../assets/videography/1.jpg";
import img2 from "../../assets/videography/2.jpg";
import img3 from "../../assets/videography/3.jpg";
import img4 from "../../assets/videography/4.jpg";
import img5 from "../../assets/videography/5.jpg";
import img6 from "../../assets/videography/6.jpg";
import img7 from "../../assets/videography/7.jpg";
import img8 from "../../assets/videography/8.jpg";
import img9 from "../../assets/videography/9.jpg";
import img10 from "../../assets/videography/10.jpg";
import img11 from "../../assets/videography/11.jpg";
import img12 from "../../assets/videography/12.jpg";
import img13 from "../../assets/videography/13.jpg";
import img14 from "../../assets/videography/14.jpg";
import img15 from "../../assets/videography/15.jpg";
import img16 from "../../assets/videography/16.jpg";
import img17 from "../../assets/videography/17.jpg";
import img18 from "../../assets/videography/18.jpg";

const videography: Video[] = [
  {
    title: "Cuba | Baseball",
    video: "p0yM-QzhzkM",
    thumbnail: img1
  },
  {
    title: "Cuba | Calehon De hamel",
    video: "DghQUjfcHtg",
    thumbnail: img2
  },
  {
    title: "South Korea | Education",
    video: "0O11fVCJr5k",
    thumbnail: img3
  },
  {
    title: "South Korea | K-Pop",
    video: "kIuJWp87BTw",
    thumbnail: img4
  },
  {
    title: "South Korea | Meditation",
    video: "iTUZqa9dgKk",
    thumbnail: img5
  },
  {
    title: "Parada Pułaskiego",
    video: "385W_FjifRU",
    thumbnail: img6
  },
  {
    title: "Polonia na PiS",
    video: "ddQtErsvaWw",
    thumbnail: img7
  },
  {
    title: "Pomnik Pozostaje",
    video: "bm4LcH9TLwU",
    thumbnail: img8
  },
  {
    title: "Pomnik Przeniesiony",
    video: "VC9_OlAg1SQ",
    thumbnail: img9
  },
  {
    title: "Premier w NYC",
    video: "XBWtZFyc18U",
    thumbnail: img10
  },
  {
    title: "Protest Polonii",
    video: "2lY5u-8X48Q",
    thumbnail: img11
  },
  {
    title: "Ruch Bezwizowy",
    video: "km9rrv4a0Wc",
    thumbnail: img12
  },
  {
    title: "Śmierć Prezydenta",
    video: "ocFLk-qEGAY",
    thumbnail: img13
  },
  {
    title: "Strajk Kobiet NYC",
    video: "lCmfPkZ3dM8",
    thumbnail: img14
  },
  {
    title: "Wonderlust Voyages",
    video: "OZbkpzeDHtI",
    thumbnail: img15
  },
  {
    title: "Pasowanie Marszałka Parady | Grand Marshall Sashing",
    video: "mhsKnDfp2pU",
    thumbnail: img15
  },
  {
    title: "PM Tusk in DC | Premier Tusk w Waszyngtonie",
    video: "PBWLCLZFmHA",
    thumbnail: img16
  },
  {
    title: "President Duda in DC | Prezydent Duda w Waszyngtonie",
    video: "CR1veSJXnb4",
    thumbnail: img17
  },
  {
    title: "President Duda in NYC | Prezydent Duda w NYC",
    video: "bDokagfyqW8",
    thumbnail: img18
  }
]

export { videography };